import { render, staticRenderFns } from "./PressArticle.vue?vue&type=template&id=6e38087a&"
import script from "./PressArticle.vue?vue&type=script&lang=js&"
export * from "./PressArticle.vue?vue&type=script&lang=js&"
import style0 from "./PressArticle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports